const __DEV__ = false;

import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import useEnhancedEffect from '../use-enhanced-effect/use-enhanced-effect.js';

var serverHandoffComplete = false;
var id = 0;
var genId = function genId() {
  return id += 1;
};
function useId(idFromProps) {
  var initialId = idFromProps || (serverHandoffComplete ? genId() : null);
  var _React$useState = React.useState(initialId),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      id = _React$useState2[0],
      setId = _React$useState2[1];
  useEnhancedEffect(function () {
    if (id === null) {
      setId(genId());
    }
  }, []);
  React.useEffect(function () {
    if (serverHandoffComplete === false) {
      serverHandoffComplete = true;
    }
  }, []);
  return id != null ? String(id) : undefined;
}

export { useId as default };
//# sourceMappingURL=use-auto-id.js.map
